export class VerifyMemberInfo{
    memberId: number;
    groupNumber: string;
    zipcode: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/verify-member-info.ts